module.exports = __webpack_public_path__ + "static/media/harri.puustjärvi.4a3504a7.jpg";